import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const BuildBigIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <g clipPath="url(#clip0_5781_16779)">
                <path
                    d="M8.68738 4.60262L7.77378 3.15702V2.04502L8.74658 1.78982L8.61458 1.28662L4.67618 2.31862C4.59458 2.08822 4.37538 1.92262 4.11778 1.92182L3.53618 1.00342L2.94258 1.92182H2.93778C2.60978 1.92182 2.34338 2.18822 2.34338 2.51622V2.92902L1.00098 3.28102L1.13298 3.78422L2.39378 3.45382C2.43938 3.55782 2.51378 3.64582 2.60658 3.70822V9.00582H4.45618V9.00262H4.45778L4.42418 3.72262C4.59618 3.61782 4.71058 3.42982 4.71058 3.21542V2.84742L7.25298 2.18102V3.25622L6.40178 4.60262H6.13138V6.32982H9.00018V4.60262H8.68738ZM3.12658 4.26342V3.80982H3.60418L3.12658 4.26342ZM3.90738 4.23862L3.91378 5.21382L3.39698 4.72342L3.90738 4.23862ZM3.64738 5.67862L3.12658 6.17382V5.18342L3.64738 5.67862ZM3.91938 6.13782L3.92578 7.13622L3.39698 6.63382L3.91938 6.13782ZM3.65938 7.60022L3.12658 8.16902V7.09382L3.65938 7.60022ZM3.54258 8.48502L3.93218 8.06982L3.93458 8.48502H3.54258ZM4.19058 3.21542C4.19058 3.25542 4.15698 3.28902 4.11618 3.28902H2.93778C2.89778 3.28902 2.86338 3.25542 2.86338 3.21542V2.51622C2.86338 2.47622 2.89778 2.44182 2.93778 2.44182H4.11618C4.15698 2.44182 4.19058 2.47622 4.19058 2.51622V3.21542ZM7.54418 3.76902L8.07138 4.60262H7.01778L7.54418 3.76902ZM8.48018 5.80902H6.65138V5.12262H8.48018V5.80902Z"
                    fill={props.fill || "#23232D"}
                />
            </g>
            <defs>
                <clipPath id="clip0_5781_16779">
                    <rect width="8" height="8" fill="white" transform="translate(1 1)" />
                </clipPath>
            </defs>
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const BuildBigIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <g clipPath="url(#clip0_5781_16779)">
                <path
                    d="M8.68738 4.60262L7.77378 3.15702V2.04502L8.74658 1.78982L8.61458 1.28662L4.67618 2.31862C4.59458 2.08822 4.37538 1.92262 4.11778 1.92182L3.53618 1.00342L2.94258 1.92182H2.93778C2.60978 1.92182 2.34338 2.18822 2.34338 2.51622V2.92902L1.00098 3.28102L1.13298 3.78422L2.39378 3.45382C2.43938 3.55782 2.51378 3.64582 2.60658 3.70822V9.00582H4.45618V9.00262H4.45778L4.42418 3.72262C4.59618 3.61782 4.71058 3.42982 4.71058 3.21542V2.84742L7.25298 2.18102V3.25622L6.40178 4.60262H6.13138V6.32982H9.00018V4.60262H8.68738ZM3.12658 4.26342V3.80982H3.60418L3.12658 4.26342ZM3.90738 4.23862L3.91378 5.21382L3.39698 4.72342L3.90738 4.23862ZM3.64738 5.67862L3.12658 6.17382V5.18342L3.64738 5.67862ZM3.91938 6.13782L3.92578 7.13622L3.39698 6.63382L3.91938 6.13782ZM3.65938 7.60022L3.12658 8.16902V7.09382L3.65938 7.60022ZM3.54258 8.48502L3.93218 8.06982L3.93458 8.48502H3.54258ZM4.19058 3.21542C4.19058 3.25542 4.15698 3.28902 4.11618 3.28902H2.93778C2.89778 3.28902 2.86338 3.25542 2.86338 3.21542V2.51622C2.86338 2.47622 2.89778 2.44182 2.93778 2.44182H4.11618C4.15698 2.44182 4.19058 2.47622 4.19058 2.51622V3.21542ZM7.54418 3.76902L8.07138 4.60262H7.01778L7.54418 3.76902ZM8.48018 5.80902H6.65138V5.12262H8.48018V5.80902Z"
                    fill={props.fill || "#23232D"}
                />
            </g>
            <defs>
                <clipPath id="clip0_5781_16779">
                    <rect width="8" height="8" fill="white" transform="translate(1 1)" />
                </clipPath>
            </defs>
        </SvgIcon>
    );
};
